var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("radio-checkbox-collection", {
    attrs: {
      "enabled-options": _vm.supportedHighlightModes,
      options: [
        {
          value: _vm.HIGHLIGHT_MODES.MOST_SUCCESSFUL_ROUTE,
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_MostSuccessful_Label"
          )
        },
        {
          value: _vm.HIGHLIGHT_MODES.LEAST_SUCCESSFUL_ROUTE,
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_LeastSuccessful_Label"
          )
        },
        {
          value: _vm.HIGHLIGHT_MODES.MOST_TAKEN_ROUTE,
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_MostTaken_Label"
          )
        },
        {
          value: _vm.HIGHLIGHT_MODES.LEAST_TAKEN_ROUTE,
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_LeastTaken_Label"
          )
        }
      ]
    },
    model: {
      value: _vm.valueModel,
      callback: function($$v) {
        _vm.valueModel = $$v
      },
      expression: "valueModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }